import {inject} from '@angular/core';
import {patchState, signalStoreFeature, type, withMethods} from '@ngrx/signals';
import {TextDataModel} from '../../models/text-data.model';
import {ResourcesService} from '../../services/resources.service';
import {setErrorMessage} from '../game.operators';
import {GameFeatureInput} from './feature-input';

/**
 * Contributes error handling: translating an error type into a user-facing
 * message (via {@link ResourcesService}) and clearing it.
 */
export function withError() {
  return signalStoreFeature(
    type<GameFeatureInput>(),
    withMethods((store, resources = inject(ResourcesService)) => ({
      /** Sets the current error from a language-file error key, or clears it with `undefined`. */
      setError(errorType: keyof TextDataModel['errors'] | undefined): void {
        if (errorType === undefined) {
          patchState(store, setErrorMessage(undefined));
          return;
        }
        const texts = resources.languageFile.value().errors;
        patchState(store, setErrorMessage(`${texts[errorType]} ${texts.tryLater}`));
      },
      /** Clears the current error. */
      clearError(): void {
        patchState(store, setErrorMessage(undefined));
      },
    }))
  );
}
